module.exports = __webpack_public_path__ + "static/media/Lab_Exercises.81bf1ffb.pdf";